import { render, staticRenderFns } from "./Datades.vue?vue&type=template&id=0169e9c4&scoped=true&"
import script from "./Datades.vue?vue&type=script&lang=js&"
export * from "./Datades.vue?vue&type=script&lang=js&"
import style0 from "./Datades.vue?vue&type=style&index=0&id=0169e9c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169e9c4",
  null
  
)

export default component.exports